import { render } from "./index.vue?vue&type=template&id=2789a7dc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductionDetails/DiningDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2789a7dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2789a7dc', __exports__)) {
    api.reload('2789a7dc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2789a7dc", () => {
    api.rerender('2789a7dc', render)
  })

}


export default __exports__